export default {
  isLoggedIn: false,
  user: {
  },
  Aue: {
    selected: {}
  },
  Ods: {
    selected: {}
  },
  CiudadSelected: null,
  idMunicipio: null,
  publicMode: false,
  imgObjetivoEstrategico: null,
  objetivoEspecifico: {
    name: '',
    id: ''
  },
  nameIndicador: null,
  loopIndicators: []
};
